import { get, remove } from '../../lib/wfApi'

export const DELETE_DEAL = 'DELETE_DEAL'
export const DELETE_DEAL_SUCCESS = 'DELETE_DEAL_SUCCESS'
export const DELETE_DEAL_FAILURE = 'DELETE_DEAL_FAILURE'
export const FETCH_DEAL_LIST = 'FETCH_DEAL_LIST'
export const FETCH_DEAL_LIST_SUCCESS = 'FETCH_DEAL_LIST_SUCCESS'
export const FETCH_DEAL_LIST_FAILURE = 'FETCH_DEAL_LIST_FAILURE'
export const PAGE_NUMBER = 'PAGE_NUMBER'
export const PAGE_TOTAL = 'PAGE_TOTAL'
export const RESET = 'RESET'

function deleteDealListRequest() {
  return {
    type: DELETE_DEAL
  }
}

function deleteDealListSuccess() {
  return {
    type: DELETE_DEAL_SUCCESS
  }
}

function deleteDealListFailure(error) {
  return {
    type: DELETE_DEAL_FAILURE,
    payload: error
  }
}

function fetchDealListRequest() {
  return {
    type: FETCH_DEAL_LIST
  }
}

function fetchDealListSuccess(data) {
  return {
    type: FETCH_DEAL_LIST_SUCCESS,
    payload: data
  }
}

function fetchDealListFailure(error) {
  return {
    type: FETCH_DEAL_LIST_FAILURE,
    payload: error
  }
}

function pageNumber(page) {
  return {
    type: PAGE_NUMBER,
    payload: page
  }
}

function pageTotal(total) {
  return {
    type: PAGE_TOTAL,
    payload: total
  }
}

export function reset() {
  return {
    type: RESET
  }
}

export function getDealList(storeId, perPage) {
  return dispatch => {
    dispatch(fetchDealListRequest())
    return get('deals', {}, { queryParams: { store_id: storeId, redeemable: true, all: true, statuses: 'all', sort: 'starts_at desc', per_page: perPage }})
      .then(response => {
        return (response.ok) ? response.json() : dispatch(fetchDealListFailure(response.errors))
      })
      .then(data => {
        dispatch(pageNumber(data.meta.page))
        dispatch(pageTotal(data.meta.page_count))
        return dispatch(fetchDealListSuccess(data.data))
      })
      .catch(() => {
        return dispatch(fetchDealListFailure(['error']))
      })
  }
}

export function deleteDeal(dealId) {
  return dispatch => {
    dispatch(deleteDealListRequest())
    return remove(`deals/${dealId}`)
      .then(response => {
        if (response.ok) {
          dispatch(deleteDealListSuccess())
        } else {
          dispatch(deleteDealListFailure(response.errors))
        }
      })
      .catch(() => dispatch(deleteDealListFailure({error: 'Error deleting deal'})))
  }
}